export default {
  compatibleChargersTitle: 'Kompatible ladebokse',
  smartChargeSupport: 'enkel Saving Mode understøtter de mest populære ladebokse på markedet.',
  smartChargeWorksVia: 'Saving Mode virker via din ladeboks. Vi understøtter blandt andet Zaptec og NexBlue.',
  chooseElAftaleHere: 'Vælg din el-aftale her',
  heroTitle1: 'Elbil oplader med elaftale',
  heroTitle2: 'til skarpe priser',
  heroTitle1Full: 'Ladeboks + el-aftale',
  heroSubtitle: 'Billig oplader med elaftale og billig strøm til elbil.',
  heroNote: '*Har du allerede ladeboks?',
  heroNoteLink: 'Se kun el-aftaler her',
  seeChargers: 'Se ladebokse',
  chooseCharger: 'Vælg din ladeboks',
  compatibleNote: 'Alle ladebokse er kompatible med enkel Saving Mode',
  alreadyHaveCharger: 'Har du allerede en',
  compatibleChargers: 'kompatibel ladeboks',
  chooseElHere: 'Vælg din el-aftale her',
  selectCharger: 'Vælg ladeboks',
  seeOtherChargers: 'Se andre opladere',
  priceFrom: 'Fra',
  plusElAftale: '+ el-aftale fra 0,72 kr./kWh',
  badgeFutureProof: 'Fremtidssikret',
  badgeReliable: 'Pålidelig',
  badgePremium: 'Premium',
  feature22kw: 'Op til 22 kW ladeeffekt',
  featureWifiBluetooth: 'Wi-Fi og Bluetooth',
  featureWifi4g: 'Wi-Fi og 4G tilslutning',
  featureRfid: 'RFID adgangskontrol',
  feature5YearWarranty: '5 års producentgaranti',
  featureV2x: 'V2X ready',
  featureV2g: 'V2G ready (hardware)',
  featureLoadBalancing: 'Dynamisk load balancing',
  featureIp54: 'IP54 vejrbestandig',
  featureSolar: 'Solcelleintegration',

  // Charger features
  keySpecs: 'Specifikationer',
  maxPower: 'Maks effekt',
  years: 'år',
  warranty: 'Garanti',
  features: 'Funktioner',
  smartChargeIncluded: 'Saving Mode inkluderet',
  smartChargeDesc: 'Prisgaranti på opladning – du betaler altid for de billigste timer i din ladeperiode. Inkluderet i alle el-aftaler.',
  spotPriceExcludes: 'Spotpris ekskl. abn, net, afgifter og moms',
  chargingPower: 'Op til {power} ladeeffekt',
  connectivity: 'Tilslutning',
  warrantyYears: '5 års producentgarantid',
  weatherproof: 'IP54 vejrbestandig',
  v2xReady: 'V2X ready',
  v2gReady: 'V2G ready (hardware)',
  solarIntegration: 'Solcelleintegration',
  rfidAccess: 'RFID adgangskontrol',
  dynamicLoadBalancing: 'Dynamisk load balancing',

  // Process
  processTitle: 'Få billig ladestander med elaftale på minutter',
  processSubtitle: 'Elbil oplader abonnement inkl. el til opladning – komplet hjemmeopladning elbil løsning',
  step1Title: 'Vælg din elbil oplader',
  step1Text: 'Billig oplader med strøm til elbil – alle mærker',
  step2Title: 'Vælg installation',
  step2Text: 'Professionel installation af autoriseret elektriker',
  step3Title: 'Vælg elaftale elbil',
  step3Text: 'Billig el til elbil og strøm til opladning inkluderet',

  // FAQ
  faqTitle: 'Ofte stillede spørgsmål om ladestander med elaftale',
  faq1Q: 'Hvad koster en elbil oplader med elaftale?',
  faq1A: 'Billig ladestander med el fra 3.999 kr. for elbil oplader + el abonnement elbil fra 0,72 kr./kWh. Komplet opladning elbil abonnement med strøm til elbil.',
  faq2Q: 'Er der abonnement på oplader med strøm?',
  faq2A: 'Ja, vores ladestander el aftale inkluderer elbil el abonnement med billig strøm elbil og oplader inkl el. Komplet elbil opladning abonnement.',
  faq3Q: 'Kan jeg få billig oplader med elaftale?',
  faq3A: 'Ja, vi tilbyder billig ladestander med el og elbil oplader med elaftale – opladning elbil hjemme løsning med el aftale med oplader.',
  faq4Q: 'Hvad får jeg med ladeboks inkl el?',
  faq4A: 'Du får oplader med elaftale, strøm til elbil opladning, el til opladning og hjemmeopladning elbil løsning – alt i ét elbil opladning abonnement.',

  // Final CTA
  finalCtaTitle: 'Klar til billig elbil oplader med strøm?',
  finalCtaSubtitle: 'Få ladestander med elaftale og el til elbil. Komplet oplader elbil løsning med strøm til elbil opladning.',
  onlyElAftale: 'Kun el-aftale',

  // Hardcoded
  exclusiveEnkel: 'fra enkel energi',
  bestPriceDkExclusiveEnkel: 'Skarpt tilbud fra enkel energi',
  result: 'Resultat:',
  danmarksBilligste: 'Skarp pris',
  cheapestSolution: 'billigste ladeløsning',
  testOf14: 'Test af 14 udbydere',
  januar2026: 'Januar 2026',
  latestRecognition: 'Seneste anerkendelser',
  
  // NicolasKJ recognition
  nicolaskjText1: 'Enkel Energi placeres som',
  nicolaskjText2: 'elselskab i uafhængig analyse uden affiliatelinks.',
  elbiilText1: 'Enkel Energi kåret som',
  elbiilText2: 'i Danmark - laveste pris på el og service.',
};